define('common/ko/fn/contains',['knockout', 'underscore', 'common/tools'], function(ko, _, tools) {
    ko.subscribable.fn.contains = _.memoize(function(value, containsChecker) {
        containsChecker = containsChecker || _.includes;
        var self = this;
        return ko.pureComputed(function() {
            return containsChecker(self(), ko.unwrap(value));
        });
    }, function(value, containsChecker) { return tools.objToHash([this, value, containsChecker]); } );
});
